import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeLogin,
  postJwtLogin,
  postSocialLogin,
} from "../../../helpers/fakebackend_helper";
import { axiosAPPApi } from "../../../helpers/api_helper";

const fireBaseBackend = getFirebaseBackend();

function* loginUser({ payload: { user, history } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(
        fireBaseBackend.loginUser,
        user.email,
        user.password
      );
      axiosAPPApi.defaults.headers.common["sc-uxr-jtkew"] = response.accessToken;
      yield put(loginSuccess(response));
    } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      let response = yield call(postJwtLogin, {
        username: user.username,
        password: user.password,
      });
      if (!response) {
        yield put(apiError("Invalid username or password"));
      } else {
        const currentUser = JSON.parse(localStorage.getItem("authUser"));
        localStorage.setItem("authUser", JSON.stringify({ ...currentUser, accessToken: response.accessToken }));
        axiosAPPApi.defaults.headers.common["sc-uxr-jtkew"] = response.accessToken;
        yield put(loginSuccess(response));
      }
    } else if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
      const response = yield call(postFakeLogin, {
        email: user.email,
        password: user.password,
      });
      const currentUser = JSON.parse(localStorage.getItem("authUser"));
      localStorage.setItem("authUser", JSON.stringify({ ...currentUser, accessToken: response.accessToken }));
      yield put(loginSuccess(response));
    }
    history('/dashboard');
  } catch (error) {
    yield put(apiError(error));
  }
}

// function* logoutUser({ payload: { history } }) {
//   try {
//     localStorage.removeItem("authUser");

//     if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
//       const response = yield call(fireBaseBackend.logout);
//       yield put(logoutUserSuccess(response));
//     }
//     console.log("history",history)
//     history("/login");
//   } catch (error) {
//     yield put(apiError(error));
//   }
// }

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser");

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(fireBaseBackend.logout);
      yield put(logoutUserSuccess(response));
    }
    history('/login');
  } catch (error) {
    yield put(apiError(error));
  }
}


function* socialLogin({ payload: { data, history, type } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      const response = yield call(
        fireBaseBackend.socialLoginUser,
        data,
        type,
      );
      const currentUser = JSON.parse(localStorage.getItem("authUser"));
      localStorage.setItem("authUser", JSON.stringify({ ...currentUser, accessToken: response.accessToken }));
      yield put(loginSuccess(response));
    } else {
      const response = yield call(postSocialLogin, data);
      const currentUser = JSON.parse(localStorage.getItem("authUser"));
      localStorage.setItem("authUser", JSON.stringify({ ...currentUser, accessToken: response.accessToken }));
      yield put(loginSuccess(response));
    }
    history("/dashboard");
  } catch (error) {
    yield put(apiError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeLatest(SOCIAL_LOGIN, socialLogin);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
